import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import MCTScorecard from 'containers/ValueCreationMetrics/MCTOperationalMetricsRedesign/metrics/MCTScorecard';
import ApplicationPerformanceScorecard from 'containers/ApplicationPerformanceRedesigned/ApplicationPerformanceStandardMetrics/ApplicationPerformanceScorecard';
import SummaryMetrics from 'containers/GlobalUserAdoption/SummaryMetrics';

const scorecards: OverviewComponentType[] = [
  () => <MCTScorecard title={'Value Creation'} />,
  () => <ApplicationPerformanceScorecard title={'App Performance'} />,
  () => <SummaryMetrics title={'User Adoption'} />,
];

const mctRegistry: ProductOverviewRegistry = {
  scorecards,
};

export default mctRegistry;
